import type { CSSObject } from '@emotion/react'
import { Color, Size, Spacing, Typography } from '@opallabs/gem'

export const momentPreviewHeaderStyles: CSSObject = {
  ...Typography.M500,
  backgroundColor: Color.light.Surface.N000,
  color: Color.light.Text.Default,
  blockSize: Spacing.M * 3.3125,
  borderEndEndRadius: Size.Rounding * 0.75,
  borderEndStartRadius: Size.Rounding * 0.75,
}

export const momentPreviewHeaderUlStyles: CSSObject = {
  paddingInline: Spacing.M * 1.25,
  margin: 0,
  inlineSize: '100%',
  blockSize: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  listStyle: 'none',
  boxSizing: 'border-box',

  li: {
    boxSizing: 'border-box',
    inlineSize: '37.5%',
    paddingInlineEnd: Spacing.M * 1.25,
    display: 'flex',
    flexDirection: 'column',

    '&:last-of-type': {
      inlineSize: '25%',
      paddingInlineEnd: 0,
    },
  },
}

export const momentPreviewHeaderCellTextStyles: CSSObject = {
  minInlineSize: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

export const momentPreviewHeaderCellHeadingStyles: CSSObject = {
  ...momentPreviewHeaderCellTextStyles,
  color: Color.light.Text.Gray,
  fontSize: 11,
  textTransform: 'uppercase',
  fontWeight: 'bold',
}
